<template>
  <div
    class="notifications d-flex flex-column border rounded bg-white"
    ondragstart="return false;"
  >
    <div v-if="notifications.length" class="notification-vertical-scroll">
      <div
        v-for="n in notifications"
        :key="n.id"
        :class="n.read ? '' : 'bg-extra-med-light-grey'"
        class="p-2 border-bottom"
      >
        <div class="date">
          <i class="fas fa-calendar-alt"></i>
          {{ n.formattedDate }}
        </div>
        <div v-html-sanitize="n.content" class="template"></div>
      </div>
    </div>
    <div v-else class="p-2 border-bottom">
      No notifications to show
    </div>
    <div v-show="count > notifications.length" class="load-more-section p-2">
      <b-spinner v-show="loading" label="Loading..." />
      <b-button
        @click="loadMoreNotifications"
        v-show="!loading"
        variant="light"
        class="load-more border"
      >
        Load More...
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";
import notificationServer from "../../server/notification";
import eocServer from "../../server/eoc";
import formSubmitterServer from "../../server/formSubmitter";

export default {
  name: "UserNotifications",
  props: ["value"],
  data() {
    return {
      notifications: [],
      pageSize: 10,
      loading: false,
      count: 0
    };
  },
  mounted() {
    this.loadMoreNotifications();

    setTimeout(() => {
      document.body.addEventListener("click", this.handleClick);
    });
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleClick);
  },
  methods: {
    ...mapMutations("layout", ["setSelectedLocation"]),
    async loadMoreNotifications() {
      this.loading = true;

      const response = await notificationServer.query({
        skip: this.notifications.length,
        pageSize: this.pageSize
      });

      const formattedNotifications = response.notifications.map(n => ({
        id: n.id,
        read: n.read,
        formattedDate: moment(n.dateTime).format("MMMM DD [at] h:mm A"),
        dateTime: n.dateTime,
        content: n.content
      }));

      this.count = response.count;
      this.notifications = [
        ...this.notifications,
        ...formattedNotifications
      ].sort((a, b) => {
        if (a.read != b.read) {
          return a.read ? 1 : -1;
        }

        return b.dateTime.localeCompare(a.dateTime);
      });

      this.loading = false;
    },
    handleClick(event) {
      this.clickOutside(event);
      this.clickAnchor(event);
    },
    clickOutside(event) {
      if (!(this.$el == event.target || this.$el.contains(event.target))) {
        this.$emit("input", false);
      }
    },
    async clickAnchor(event) {
      if (this.$el.contains(event.target) && event.target.tagName === "A") {
        event.preventDefault();
        const href = event.target.getAttribute("href").replace(/\/#\//, "");
        const id = this.getEntityId(href);

        switch (href) {
          case href.match(/episode-of-care/)?.input: {
            this.redirectByEocLocation(id, href);
            break;
          }
          case href.match(/document/)?.input: {
            const doc = await formSubmitterServer.get(id);
            this.redirectByEocLocation(doc.episodeOfCareId, href);
            break;
          }
          case href.match(/home/)?.input: {
            this.$router.push(href).catch(() => {});
            break;
          }
          default: {
            throw new Error("href did not match current implementation");
          }
        }

        this.$emit("input", false);
      }
    },
    getEntityId(href) {
      return href
        .split("/")
        .filter(Boolean)
        .at(-1);
    },
    async redirectByEocLocation(eocId, href) {
      const eoc = await eocServer.get(eocId);
      if (eoc.location.id == this.selectedLocation) {
        this.$router.push(href).catch(() => {});
      } else {
        this.$dialog
          .alert(
            {
              title:
                "The element you are trying to access is in a different Location. Are you sure you want to change Locations?"
            },
            { view: "confirm" }
          )
          .then(() => {
            this.$router.push({
              path: href,
              query: { location: eoc.location.id }
            });
          });
      }
    }
  },
  computed: {
    ...mapState("layout", ["selectedLocation"])
  }
};
</script>

<style scoped>
.notifications * {
  user-select: none;
}
.notifications a {
  user-select: auto;
}
.notification-vertical-scroll {
  max-height: 562px;
  overflow: auto;
}
.load-more-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.date {
  font-size: 13px;
  color: #aaa;
}
.date i {
  font-size: 12px;
  margin-right: 2px;
}
.template {
  font-size: 13px;
}
.btn.load-more {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
</style>
